import type { RecoilState, SetterOrUpdater } from 'recoil';
import { atom, useRecoilState } from 'recoil';

export const shouldUpdateHangingProtocolClassifications: RecoilState<boolean> = atom<boolean>({
  key: 'shouldUpdateHangingProtocolClassifications',
  default: true,
});

export const useShouldUpdateHangingProtocolClassifications = (): [
  boolean,
  SetterOrUpdater<boolean>,
] => {
  return useRecoilState(shouldUpdateHangingProtocolClassifications);
};
